var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import React from 'react';
// Here we add the icons we want to use in the configuration
export var MUI_ICONS = {
    MarkEmailReadIcon: MarkEmailReadIcon,
    HelpOutlineIcon: HelpOutlineIcon,
};
var MUIIcon = function (_a) {
    var Icon = _a.iconComponent, styleProp = _a.styleProp;
    return (_jsx(Icon, { style: __assign({ fontSize: 24 }, styleProp), color: "inherit" }));
};
export default MUIIcon;
